import { ChooseAccountPage } from "src/pages/Signup/ChooseAccount";
export default ChooseAccountPage;
